export default __webpack_public_path__ + "static/media/357.60d7727a.png";